module.exports = __webpack_public_path__ + "media/luxury-2026/loch-fireplace-straight-ed99adb4.jpg";